import { AnonymousChat } from './AnonymousChat';
import { LiveChat } from './LiveChat';
import { MEPSDKType, MoxoChatTypeEnum, MoxoConfig } from './types';

export type MoxoInstance = AnonymousChat | LiveChat | null;

export class MoxoAccessManager {
  private static instance: MoxoAccessManager | null = null;

  private moxoClient: MoxoInstance = null;
  private moxoSdk: MEPSDKType | null = null

  constructor() {
    if (MoxoAccessManager.instance) {
      return MoxoAccessManager.instance;
    }
    MoxoAccessManager.instance = this;
  }

  public client(config: MoxoConfig): MoxoInstance {
    if (!this.moxoClient) {
      this.moxoClient = this.create(config);
    }
    return this.moxoClient;
  }

  private create(config: MoxoConfig): MoxoInstance {
    const { domain, clientType, containerId, token } = config;

    const moxo = (window as unknown as { mepsdk: MEPSDKType })
      .mepsdk as MEPSDKType;

    if (moxo) {
      this.moxoSdk = moxo

      switch (clientType) {
        case MoxoChatTypeEnum.ANONYMOUS:
          return new AnonymousChat(moxo, domain, containerId);
        case MoxoChatTypeEnum.AUTHENTICATED:
          if (token) {
            return new LiveChat(moxo, domain, token, containerId);
          }
          throw new Error(
            'Moxo: Token and userId are required for authenticated chat',
          );
        default:
          throw new Error(
            'Moxo: Invalid configuration for MoxoInstanceManager initialization',
          );
      }
    }
    return null;
  }

  public destroy(){
    if (this.moxoSdk){
      this.moxoSdk.unlink()
      this.moxoClient = null
    }
  }
}
